"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _moment = _interopRequireDefault(require("moment")),
    _UserProfile = _interopRequireDefault(require("../../../common/UserProfile/UserProfile"));

require("../styles/_comment-footer.scss");

function CommentFooter(a) {
  var b = a.user,
      c = b.imageUrl,
      d = b.name,
      e = b.isUser,
      f = a.updatedAt,
      g = a.handleDelete;
  return _react["default"].createElement("div", {
    className: "comment-footer"
  }, _react["default"].createElement(_UserProfile["default"], {
    imageUrl: c,
    name: d,
    isUser: e
  }), _react["default"].createElement("div", {
    className: "comment-footer__right"
  }, _react["default"].createElement(_uiKit.Text, {
    noMargin: !0,
    timestamp: !0
  }, (0, _moment["default"])(f, "x").format("MMM D [at] hh:mm A")), e ? _react["default"].createElement(_uiKit.Icon, {
    onClick: g,
    name: "trash",
    color: "regent",
    hoverColor: "redApple",
    size: 15
  }) : null));
}

var _default = CommentFooter;
exports["default"] = _default;